import { RegionSuggestElem } from '../typings/regions';
import { RegionInputIds } from '../typings/regions';

export const REGIONS_SET_TEXT = 'REGIONS_SET_TEXT';
export type REGIONS_SET_TEXT = typeof REGIONS_SET_TEXT;

export const REGIONS_SET_SUGGEST_LIST = 'REGIONS_SET_SUGGEST_LIST';
export type REGIONS_SET_SUGGEST_LIST = typeof REGIONS_SET_SUGGEST_LIST;

export const REGIONS_FETCH_SUGGEST_LIST = 'REGIONS_FETCH_SUGGEST_LIST';
export type REGIONS_FETCH_SUGGEST_LIST = typeof REGIONS_FETCH_SUGGEST_LIST;

export const REGIONS_SET_GEOID = 'REGIONS_SET_GEOID';
export type REGIONS_SET_GEOID = typeof REGIONS_SET_GEOID;

export interface RegionSetTextAction {
    type: REGIONS_SET_TEXT;
    regionInputId: RegionInputIds;
    text: string;
}

export interface RegionSetSuggesListAction {
    type: REGIONS_SET_SUGGEST_LIST;
    regionInputId: RegionInputIds;
    suggestList: RegionSuggestElem[];
}

export interface RegionFetchSuggestListAction {
    type: REGIONS_FETCH_SUGGEST_LIST;
    regionInputId: RegionInputIds;
    part: string;
    itemsCount: number;
}

export interface RegionSetGeoIdAction {
    type: REGIONS_SET_GEOID;
    regionInputId: RegionInputIds;
    geoId: number;
}

export function regionSetText(
    regionInputId: RegionInputIds,
    text: string
): RegionSetTextAction {
    return {
        type: REGIONS_SET_TEXT,
        regionInputId,
        text
    };
}

export function regionSetSuggestList(
    regionInputId: RegionInputIds,
    suggestList: RegionSuggestElem[]
): RegionSetSuggesListAction {
    return {
        type: REGIONS_SET_SUGGEST_LIST,
        regionInputId,
        suggestList
    };
}

export function regionFetchSuggestList(
    regionInputId: RegionInputIds,
    part: string,
    itemsCount: number
): RegionFetchSuggestListAction {
    return {
        type: REGIONS_FETCH_SUGGEST_LIST,
        regionInputId,
        part,
        itemsCount
    };
}

export function regionSetGeoId(
    regionInputId: RegionInputIds,
    geoId: number
): RegionSetGeoIdAction {
    return {
        type: REGIONS_SET_GEOID,
        regionInputId,
        geoId
    };
}

export type RegionsAction =
    | RegionSetTextAction
    | RegionSetSuggesListAction
    | RegionSetGeoIdAction
    | RegionFetchSuggestListAction;
